<app-cej-hero (click)="scrollTo()"></app-cej-hero>

<app-cej-v2-what-is-it></app-cej-v2-what-is-it>

<app-cej-v2-advantages (canBenefitButtonClick)="scrollTo()"></app-cej-v2-advantages>

<app-cej-v2-allocation></app-cej-v2-allocation>

<app-cej-v2-testimonials></app-cej-v2-testimonials>

<app-cej-orientation-form [formId]="cejFormId" class="wrapper--blue"></app-cej-orientation-form>

<app-cej-v2-contact></app-cej-v2-contact>

<app-cej-v2-download-app></app-cej-v2-download-app>
